/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Swap_ReferenceInputs */

const en_us2_swap_reference = /** @type {(inputs: Swap_ReferenceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Reference`)
};

const pt_br2_swap_reference = /** @type {(inputs: Swap_ReferenceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Referência`)
};

const es_419_swap_reference = /** @type {(inputs: Swap_ReferenceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Referencia`)
};

const pt_pt2_swap_reference = /** @type {(inputs: Swap_ReferenceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Referência`)
};

const fr_fr2_swap_reference = /** @type {(inputs: Swap_ReferenceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Référence`)
};

const de_de2_swap_reference = /** @type {(inputs: Swap_ReferenceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Referenz`)
};

const it_it2_swap_reference = /** @type {(inputs: Swap_ReferenceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Riferimento`)
};

/**
* | output |
* | --- |
* | "Reference" |
*
* @param {Swap_ReferenceInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const swap_reference = /** @type {((inputs?: Swap_ReferenceInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Swap_ReferenceInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_swap_reference(inputs)
	if (locale === "es-419") return es_419_swap_reference(inputs)
	if (locale === "pt-PT") return pt_pt2_swap_reference(inputs)
	if (locale === "fr-FR") return fr_fr2_swap_reference(inputs)
	if (locale === "de-DE") return de_de2_swap_reference(inputs)
	if (locale === "it-IT") return it_it2_swap_reference(inputs)
	return en_us2_swap_reference(inputs)
});
export { swap_reference as "swap.reference" }